import { render, staticRenderFns } from "./TableBox.vue?vue&type=template&id=99a38f3e&"
import script from "./TableBox.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TableBox.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports